<radio-buttons-v2
  [disabled]="!!props.disabled"
  [items]="props.items"
  [horizontal]="props.horizontal"
  [value]="formControl.value"
  [key]="field.dataId"
  (selectItem)="selectItemValue($event)"
></radio-buttons-v2>
